import React from 'react';
import Alert from "@material-ui/lab/Alert";
import {useDispatch, useSelector} from "react-redux";
import {setSwBookState} from "../../../../../store/reducers/search-widget";
import {Grid, useMediaQuery, useTheme, Snackbar} from "@material-ui/core";

const BookAlertConnected = () => {

    const {breakpoints} = useTheme();
    const isMobile = useMediaQuery(breakpoints.down('sm'));
    const alertMessage = useSelector(state => state.sw.book.alertMessage);
    const dispatch = useDispatch();

    if (!alertMessage) return null;

    if (isMobile) {
        return (
            <Snackbar autoHideDuration={6000} anchorOrigin={{vertical: 'top', horizontal: 'right'}} onClose={() => dispatch(setSwBookState({alertMessage: null}))} open>
                <Alert onClose={() => dispatch(setSwBookState({alertMessage: null}))} {...alertMessage}/>
            </Snackbar>
        );
    }

    return (
        <Grid xs={12} sm={12} item>
            <Alert onClose={() => dispatch(setSwBookState({alertMessage: null}))} {...alertMessage}/>
        </Grid>
    );
};

export default BookAlertConnected;